import type { TCreateSlice } from "@/store";
import type { TDashboardFilter } from "@/ui/organisms/dashboardTypes";

type TStateDashboardAnalytics = {
    dashboardTab: number;
    dashboardFilter: TDashboardFilter;
};

type TActionsPublic = {
    setDashboardFilter: (value: TDashboardFilter) => void;
};

export const initialStateAnalytics = {
    dashboardTab: 0,
    dashboardFilter: "all",
} as const satisfies TStateDashboardAnalytics;

export type TSliceDashboardAnalytics = TStateDashboardAnalytics &
    TActionsPublic;

export const createSliceDashboardAnalytics: TCreateSlice<
    TSliceDashboardAnalytics,
    Record<string, never>
> = () => set => {
    const actionsPublic: TActionsPublic = {
        setDashboardFilter: (value: TDashboardFilter) => {
            set(
                { dashboardFilter: value },
                false,
                "dashboardAnalytics/setDashboardFilter",
            );
        },
    };

    return {
        ...initialStateAnalytics,
        ...actionsPublic,
    };
};
